import React from 'react';
import { BrokerMark } from '../../components/dashboard/myData/myWidgetUi';
import { PERIODS } from './personalAnalytics';

/* Bits shared by the personal Results and Portfolio Simulator pages. */

export function SourceName({ source }) {
  return (
    <span className="myr-name">
      {source.kind === 'account'
        ? <BrokerMark broker={source.broker} name={source.name} size={20} />
        : <span className="myr-strat-mark" style={{ background: source.color }} aria-hidden="true">S</span>}
      <span className="myr-name-text">{source.name}</span>
      {source.kind === 'strategy' ? <span className="myr-tag">My strategy</span> : null}
    </span>
  );
}

export function PeriodPills({ value, onChange }) {
  return (
    <div className="mydw-pills" role="tablist" aria-label="Period">
      {PERIODS.map((p) => (
        <button key={p.value} type="button" role="tab" aria-selected={value === p.value} className={value === p.value ? 'active' : ''} onClick={() => onChange(p.value)}>
          {p.label}
        </button>
      ))}
    </div>
  );
}

export function ProUpsell({ what, onUpgrade }) {
  return (
    <div className="myr-state">
      <strong>{what} is part of RiskLo Pro</strong>
      <span>Connect your brokerage accounts or bring your own strategies, then see the numbers and test combinations here.</span>
      {onUpgrade ? <button type="button" className="mys-btn is-primary" onClick={() => onUpgrade()}>See Pro</button> : null}
    </div>
  );
}

export function EmptySources({ onNavigate, onStrategies }) {
  return (
    <div className="myr-state">
      <strong>Nothing to show yet</strong>
      <span>Connect a brokerage account, or add one of your own strategies from a backtest CSV or a webhook.</span>
      <div className="mys-actions">
        {onNavigate ? <button type="button" className="mys-btn is-primary" onClick={() => onNavigate('home')}>Connect an account</button> : null}
        <button type="button" className="mys-btn" onClick={onStrategies}>Add a strategy</button>
      </div>
    </div>
  );
}

export const fmtPf = (pf) => (pf == null ? '—' : pf === Infinity ? '∞' : pf.toFixed(2));
export const monthLabel = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};
